import { useSelector } from 'react-redux'
import ClubsAndSocieties from '../components/campusLife/popUps/clubsAndSocieties'
import HealthAndWellness from '../components/campusLife/popUps/healthAndWellness'
import StudentGuidanceUnit from '../components/campusLife/popUps/studentGuidanceUnit'
import StudentLifeCard from '../components/campusLife/studentLifeCard'
import Heading from '../components/heading'
import { DecodeHtml } from '../utils/decodeHtml'
import { retrunAssets, returnNotImage } from '../utils/getAssets'

const StudentLife = () => {
  const state = useSelector(state => state.campusLifeTab)
  const studentLife = state?.data?.properties
  const studentLifeDescription = DecodeHtml({
    html: studentLife?.studentLifeDescription?.markup
  })
  const childs = [
    {
      title: 'GUIDANCE & COUNSELLING',
      children: (
        <StudentGuidanceUnit
          url={
            studentLife?.studentLifeOffers?.items[0]?.content?.properties
              ?.learnMore?.route?.path
          }
        />
      )
    },
    {
      title: 'HEALTH & WELLNESS',
      children: <HealthAndWellness />
    },
    {
      title: 'CLUBS & SOCIETIES',
      children: <ClubsAndSocieties />
    }
  ]
  const studentLifeOffers = studentLife?.studentLifeOffers?.items?.map(
    (item, index) => {
      let item1 = item?.content?.properties
      const obj =
        item1?.title === 'Edu Tourism'
          ? {
              img:
                item1?.backgroundImage != null
                  ? retrunAssets(item1?.backgroundImage[0]?.url)
                  : returnNotImage(),
              title: item1?.title,
              description: DecodeHtml({ html: item1?.content?.markup }),
              reverse: index % 2 === 0 ? false : true,
              // children: childs.find(child => child.title.toLowerCase() === item1?.title?.toLowerCase())?.children || null
              externalLink:
                item1?.title === 'Edu Tourism'
                  ? item1?.link[0]?.route?.path
                  : null,
              children: null
            }
          : {
              img:
                item1?.image != null
                  ? retrunAssets(item1?.image[0]?.url)
                  : retrunAssets(),
              title: item1?.title,
              description: DecodeHtml({ html: item1?.description?.markup }),
              reverse: index % 2 === 0 ? false : true,
              // children: childs.find(child => child.title.toLowerCase() === item1?.title?.toLowerCase())?.children || null
              externalLink: null,
              children: (
                <StudentGuidanceUnit
                  url={
                    studentLife?.studentLifeOffers?.items[index]?.content
                      ?.properties?.learnMore?.route?.path
                  }
                />
              )
            }
      return obj
    }
  )

  return (
    <div className='p-4 lg:p-8 lg:px-16'>
      <div className='flex flex-col gap-8'>
        <div className='flex flex-col gap-3 items-center'>
          <Heading name='Student Life' color='text-blue-500' />
          <h1 className='text-center w-auto  text-slate-900 text-5xl font-bold  capitalize leading-tight'>
            Navigating University Life
          </h1>
          <p className='w-auto   2xl:max-w-7xl text-justify lg:text-center text-sky-950 text-opacity-70 text-base font-normal  leading-normal'>
            {studentLifeDescription}
          </p>
        </div>

        <div className='flex flex-col gap-20 my-8 w-full'>
          {studentLifeOffers?.map((card, index) => (
            <StudentLifeCard key={index} {...card} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default StudentLife
